import { render, staticRenderFns } from "./general-tab.vue?vue&type=template&id=2fe03e3c&scoped=true"
import script from "./general-tab.vue?vue&type=script&lang=js"
export * from "./general-tab.vue?vue&type=script&lang=js"
import style0 from "./general-tab.vue?vue&type=style&index=0&id=2fe03e3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe03e3c",
  null
  
)

export default component.exports